import { render, staticRenderFns } from "./GoldenTicketExt.vue?vue&type=template&id=dffeda76&scoped=true&"
import script from "./GoldenTicketExt.vue?vue&type=script&lang=js&"
export * from "./GoldenTicketExt.vue?vue&type=script&lang=js&"
import style0 from "./GoldenTicketExt.vue?vue&type=style&index=0&id=dffeda76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffeda76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
